// Shared headers for authenticated API calls.
// X-Mock-Ip is only needed locally: geoip-lite can't resolve localhost/private
// IPs to a country, so verifyAreaRestriction has nothing to look up in dev.
// import.meta.env.DEV is false in a production build, so this never ships.
//
// Auth itself is handled entirely by the httpOnly `access_token` cookie the
// backend sets on login/register — JS can't (and shouldn't) read or attach it
// manually. As long as `credentials: "include"` is set on the fetch call, the
// browser sends it automatically, so there's no Authorization header here.

const APP_ID = "9d6f8055-5d96-4c30-8876-c0e33ab48369";
const DEV_MOCK_IP = "105.95.255.255";

export const buildHeaders = (extra = {}) => {
    const headers = {
        "X-App-Id": APP_ID,
        ...extra,
    };

    if (process.env.DEV) {
        headers["X-Mock-Ip"] = DEV_MOCK_IP;
    }

    return headers;
}

export const buildDeviceInfoHeader = () => JSON.stringify({
    connectionType: navigator.connection?.effectiveType || "unknown",
    platform: navigator.platform || "unknown",
    userAgent: navigator.userAgent,
});

